import { DatePipe } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Table } from 'primeng/table';
import {
  ProgramTypesGUID,
  EventsPaymentScheduleTab
} from '../../../models/_enum-collections';
import { ApiResponse } from '../../../models/api-response.model';
import {
  EventMilestone2PaymentBatchEvents,
  EventMilestone2PaymentBatchDetails
} from '../../../models/event-milestone2-payment-batch-events.model';
import { EventPaymentBatchStatusDropDown } from '../../../models/event-payment-batch-status.model';
import { AppConstants } from '../../common/app-constants';
import { CommonService } from '../../common/common.service';
import { EventPaymentScheduleService } from '../../services/event-payment-schedule.service';
import { CommonSharedModule } from '../../common/shared.module';
import eventNewPaymentBatchMilestone2Config from './event-new-payment-batch-milestone2.component-config.json';

@Component({
  selector: 'app-event-new-payment-batch-milestone2',
  templateUrl: './event-new-payment-batch-milestone2.component.html',
  styleUrls: ['./event-new-payment-batch-milestone2.component.scss'],
  standalone: true,
  imports: [CommonSharedModule]
})
export class EventNewPaymentBatchMilestone2Component implements OnInit {
  @ViewChild('dt', { static: false }) dt!: Table;
  engcols!: any[];
  showForm = true;
  loading = false;
  loadingIcon = 'fa-circle-o-notch';
  msgs: any[] = [];
  paymentBatchForm!: FormGroup;
  paymentBatchStatus: EventPaymentBatchStatusDropDown[] = [];
  eventList: EventMilestone2PaymentBatchEvents[] = [];
  selectedEvents: EventMilestone2PaymentBatchEvents[] = [];
  createPaymentBatch!: EventMilestone2PaymentBatchDetails;
  apires!: ApiResponse;
  totalRecords!: number;
  currentPageInfo!: string;
  dataViewRecsPerPage!: number;
  tblPageNumber!: number;
  pageLinksPerPage!: number;
  programTypeGuid: string = ProgramTypesGUID.Events;
  isMRPP = false;
  engagementId!: string;
  engagementName!: string;
  payoutMetric!: string;

  constructor(
    private commonService: CommonService,
    private eventPaymentScheduleService: EventPaymentScheduleService,
    private formBuilder: FormBuilder,
    public router: Router
  ) {}

  ngOnInit() {
    this.loading = true;
    this.dataViewRecsPerPage = 15;
    this.pageLinksPerPage = AppConstants.dataListPagerLinks;
    this.isMRPP =
      this.getProgramTypeGuid() == ProgramTypesGUID.MRPP ? true : false;
    this.getEventSheduleHeaderFilelds();
    this.engcols = [
      { field: 'eventKey', header: 'Event Key' },
      { field: 'eventRegistrationId', header: this.engagementId },
      { field: 'eventName', header: this.engagementName },
      { field: 'partnerName', header: 'Partner Name' },
      { field: 'customerTenantId', header: 'Customer TenantID' },
      { field: 'payoutMetric', header: this.payoutMetric },
      { field: 'tier', header: 'Milestone 2 Tier' },
      { field: 'maturityStatus', header: 'Maturity Status' },
      { field: 'maturityDate', header: 'Maturity Date' },
      { field: 'fundingAmount', header: 'Funding Amount' },
      { field: 'partnerLocation', header: 'Partner Location' },
      { field: 'fiscalYear', header: 'Fiscal Year' },
      { field: 'profileStatus', header: 'ProfileStatus' },
      { field: 'partnerPriority', header: 'Partner Priority' },
      { field: 'blockedStatus', header: 'Blocked Status' },
      { field: 'partnerId', header: 'Partner ID' },
      { field: 'payeeName', header: 'Payee Name' },
      { field: 'contactName', header: 'Contact Name' },
      { field: 'contactEmail', header: 'Contact Email' },
      { field: 'emailLanguage', header: 'Email Language' },
      { field: 'accountCode', header: 'Account Code' },
      {
        field: 'internalOrderOrCostCenter',
        header: 'Internal Code or Cost Center'
      },
      { field: 'currency', header: 'Currency' },
      { field: 'amount', header: 'Amount' },
      { field: 'netAmount', header: 'Net Amount' },
      { field: 'taxAmount', header: 'Tax Amount' },
      { field: 'msInvoiceNumber', header: 'MS Invoice Number' },
      { field: 'msInvoicePaidDate', header: 'MS Invoice Paid Date' },
      {
        field: 'paymentCentralTransactionId',
        header: 'Payment Central Transaction ID'
      },
      { field: 'paymentDocumentNumber', header: 'Payment Document Number' },
      { field: 'programType', header: 'Program Type' },
      { field: 'payeeID', header: 'Payee ID' }
    ];

    this.paymentBatchForm = this.formBuilder.group({
      paymentBatchName: [''],
      paymentBatchScheduleDate: ['', [Validators.required]],
      anticipatedPaymentDate: ['', [Validators.required]],
      actualPaymentCentralDate: [''],
      paymentBatchStatus: ['', [Validators.required]],
      selectedEvents: [''],
      amount: [''],
      partnerId: [''],
      payeeName: [''],
      payeeID: [''],
      contactName: [''],
      contactEmail: [''],
      emailLanguage: [''],
      accountCode: [''],
      internalOrderOrCostCenter: [''],
      currency: [''],
      netAmount: [''],
      taxAmount: [''],
      msInvoiceNumber: [''],
      msInvoicePaidDate: [''],
      paymentCentralTransactionId: [''],
      programType: ['']
    });

    this.getPaymentBatchStatus();
    this.getEventDetails();
  }

  getPaymentBatchStatus() {
    this.eventPaymentScheduleService
      .getPaymentBatchStatus()
      .subscribe(statusList => {
        this.paymentBatchStatus = statusList;
      });
  }

  getEventDetails() {
    const programTypeGuid = this.getProgramTypeGuid();
    this.eventPaymentScheduleService
      .getMilestone2PaymentScheduleEventDetails(programTypeGuid)
      .subscribe(evtList => {
        this.eventList = evtList;
        this.totalRecords = this.eventList.length;
        if (this.totalRecords === 0) {
          this.currentPageInfo = 'No Record Found';
          this.loading = false;
        } else {
          this.currentPageInfo =
            'Showing 1 - ' +
            1 * this.dataViewRecsPerPage +
            ' of ' +
            this.totalRecords +
            ' Records';
          this.loading = false;
        }
      });
  }

  pageChange(e) {
    this.tblPageNumber = e.first;
    if (e.first + this.dataViewRecsPerPage > this.totalRecords) {
      this.currentPageInfo =
        'Showing ' +
        (this.tblPageNumber + 1) +
        ' - ' +
        this.totalRecords +
        ' of ' +
        this.totalRecords +
        ' Records';
    } else {
      this.currentPageInfo =
        'Showing ' +
        (this.tblPageNumber + 1) +
        ' - ' +
        (this.tblPageNumber + this.dataViewRecsPerPage) +
        ' of ' +
        this.totalRecords +
        ' Records';
    }
  }

  applyFilter(event) {
    this.totalRecords = event.filteredValue.length;
    if (this.totalRecords === 0) {
      this.currentPageInfo = 'No Record Found';
    }
    if (this.totalRecords > 0 && this.totalRecords > this.dataViewRecsPerPage) {
      this.currentPageInfo =
        'Showing 1 - ' +
        1 * this.dataViewRecsPerPage +
        ' of ' +
        this.totalRecords +
        ' Records';
    }
    if (
      this.totalRecords > 0 &&
      this.totalRecords <= this.dataViewRecsPerPage
    ) {
      this.currentPageInfo =
        'Showing 1 - ' +
        this.totalRecords +
        ' of ' +
        this.totalRecords +
        ' Records';
    }
  }

  reset() {
    if (this.dt) {
      this.dt.sortField = 'eventRegistrationId';
      this.dt.sortOrder = -1;

      this.dt.reset();
    }

    if (this.eventList === null || this.eventList.length === 0) {
      this.totalRecords = 0;
      this.currentPageInfo = 'No Records Found';
    } else {
      this.totalRecords = this.eventList.length;
      if (this.totalRecords > 0 && this.totalRecords > this.totalRecords) {
        this.currentPageInfo =
          'Showing 1 - ' +
          1 * this.totalRecords +
          ' of ' +
          this.totalRecords +
          ' Records';
      }

      if (this.totalRecords > 0 && this.totalRecords <= this.totalRecords) {
        this.currentPageInfo =
          'Showing 1 - ' +
          this.totalRecords +
          ' of ' +
          this.totalRecords +
          ' Records';
      }
    }
  }

  selectRow(e, l) {
    const eventListItem = this.eventList.find(
      item => item.eventRegistrationId === l.eventRegistrationId
    );

    if (eventListItem) {
      if (e === true) {
        eventListItem.editCheckBox = true;
      } else {
        eventListItem.editCheckBox = false;
      }
    }
  }

  onSubmit() {
    this.loading = true;
    const datePipe = new DatePipe('en-US');
    const ScheduleDate = datePipe.transform(
      this.paymentBatchForm.controls['paymentBatchScheduleDate'].value,
      'MM/dd/yyyy'
    );
    const anticipatedPaymentDate = datePipe.transform(
      this.paymentBatchForm.controls['anticipatedPaymentDate'].value,
      'MM/dd/yyyy'
    );
    const actualPaymentCentralDate = datePipe.transform(
      this.paymentBatchForm.controls['actualPaymentCentralDate'].value,
      'MM/dd/yyyy'
    );

    this.createPaymentBatch = {
      paymentBatchScheduleDate: this.getDate(
        new Date(ScheduleDate || '')
      ).toISOString(),
      anticipatedPaymentDate: this.getDate(
        new Date(anticipatedPaymentDate || '')
      ).toISOString(),
      actualPaymentCentralDate:
        actualPaymentCentralDate
          ? this.getDate(new Date(actualPaymentCentralDate)).toISOString()
          : null,
      paymentBatchStatusId:
        this.paymentBatchForm.controls['paymentBatchStatus'].value
          .eventPaymentBatchStatusId,
      programTypeGuid: this.programTypeGuid,
      events: []
    };

    if (
      this.selectedEvents.length !== 0 ||
      this.selectedEvents.length !== undefined
    ) {
      this.selectedEvents.forEach(ele => {
        this.createPaymentBatch.events.push(ele);
      });
    }

    if (this.selectedEvents.length === 0) {
      this.loading = false;
      this.msgs = [];
      this.msgs.push({
        severity: 'error',
        detail: 'Please select any one Event from the list'
      });
      setTimeout(() => {
        this.msgs = [];
      }, 5000);
      return;
    }

    this.eventPaymentScheduleService
      .createMilestone2PaymentBatch(this.createPaymentBatch)
      .subscribe(
        messageResponse => {
          this.loading = false;
          this.apires = messageResponse;
          if (this.apires.success === true) {
            this.msgs = [];
            this.msgs.push({
              severity: 'success',
              detail: 'Payment Batch Created Successfully'
            });
            this.selectedEvents = [];
            this.paymentBatchForm.reset();
            setTimeout(() => {
              this.router.navigate(['events-payment-schedule'], {
                queryParams: { tab: EventsPaymentScheduleTab.Milestone2 },
                skipLocationChange: true
              });
            }, 2000);
          } else if (this.apires.success === false) {
            this.loading = false;
            this.msgs = [];
            this.msgs.push({
              severity: 'error',
              detail: this.apires.errorMessages
                ? this.apires.errorMessages[0]
                : 'An error occurred'
            });
          }
          this.showForm = false;
        },
        error => {
          this.loading = false;
          this.msgs = [];
          let errors: string[] = [];
          if (error.status === 400) {
            errors = this.commonService.getBadRequestErrors(error);
            for (const msg of errors) {
              this.msgs.push({ severity: 'warn', detail: msg });
            }
          } else {
            this.msgs.push({
              severity: 'warn',
              detail: 'Sorry an Error Occured while Creating Payment Batch'
            });
          }
          this.showForm = true;
        }
      );
  }

  cancelSearchNav() {
    this.router.navigate(['events-payment-schedule'], {
      queryParams: { tab: EventsPaymentScheduleTab.Milestone2 },
      skipLocationChange: true
    });
  }

  private getDate(date: Date): Date {
    return new Date(date.getTime() - date.getTimezoneOffset() * 60 * 1000);
  }
  getEventSheduleHeaderFilelds() {
    this.programTypeGuid = this.getProgramTypeGuid();
    const programTypeConfig = eventNewPaymentBatchMilestone2Config.program.find(
      obj => obj.programTypeGuid === this.programTypeGuid
    );
    this.engagementId =
      programTypeConfig?.element.find(
        obj => obj.id === 'engagementRegistrationId'
      )?.displayName || '';
    this.engagementName =
      programTypeConfig?.element.find(obj => obj.id === 'engagementName')
        ?.displayName || '';
    this.payoutMetric =
      programTypeConfig?.element.find(obj => obj.id === 'payoutMetric')
        ?.displayName || '';
  }
  isHidden(element: string) {
    this.programTypeGuid = this.getProgramTypeGuid();
    const programTypeConfig = eventNewPaymentBatchMilestone2Config.program.find(
      obj => obj.programTypeGuid === this.programTypeGuid
    );
    if (programTypeConfig?.hiddenElements.find(obj => obj.name == element)) {
      return true;
    } else return false;
  }

  getProgramTypeGuid() {
    if (history.state.programTypeGuid) return history.state.programTypeGuid;
    else if (localStorage.getItem('programTypeGuid')) {
      const guid = localStorage.getItem('programTypeGuid');
      return guid as ProgramTypesGUID;
    } else return ProgramTypesGUID.Events;
  }
}
